import React from "react";
import type { Consequence } from "../../../../components/RCA/types";

interface RCAConsequencesSectionProps {
  consequences: Consequence[];
  onAdd: () => void;
  onUpdate: (index: number, field: keyof Consequence, value: any) => void;
  onRemove: (index: number) => void;
  readOnly: boolean;
}

const RCAConsequencesSection: React.FC<RCAConsequencesSectionProps> = ({
  consequences,
  onAdd,
  onUpdate,
  onRemove,
  readOnly,
}) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">F. Consequences</h3>
        {!readOnly && (
          <button
            type="button"
            onClick={onAdd}
            className="px-4 py-2 bg-[#0fa9a6] text-white rounded hover:bg-[#0d8f8c]"
          >
            Add Consequence
          </button>
        )}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              <th className="border p-2">Sr. No</th>
              <th className="border p-2">Type of Consequence</th>
              <th className="border p-2">Yes / No</th>
              <th className="border p-2">Remark</th>
              {!readOnly && <th className="border p-2">Action</th>}
            </tr>
          </thead>
          <tbody>
            {(!consequences || consequences.length === 0) ? (
              <tr>
                <td
                  colSpan={readOnly ? 4 : 5}
                  className="border p-4 text-center text-gray-500"
                >
                  No consequences added
                </td>
              </tr>
            ) : (
              consequences.map((item, index) => (
                <tr key={index} className={item.isYes ? "bg-red-200" : ""}>
                  <td className="border p-2 text-center">{item.srNo}</td>
                  <td className="border p-2">
                    <input
                      type="text"
                      value={item.type || ""}
                      onChange={(e) =>
                        onUpdate(index, "type", e.target.value)
                      }
                      className={`w-full p-1 border rounded ${item.isYes ? "bg-white/80" : ""}`}
                      readOnly={readOnly}
                    />
                  </td>
                  <td className="border p-2 text-center">
                    <select
                      value={item.isYes ? "Yes" : "No"}
                      onChange={(e) =>
                        onUpdate(index, "isYes", e.target.value === "Yes")
                      }
                      className={`w-full p-1 border rounded ${item.isYes ? "bg-white/80" : ""}`}
                      disabled={readOnly}
                    >
                      <option value="No">No</option>
                      <option value="Yes">Yes</option>
                    </select>
                  </td>
                  <td className="border p-2">
                    <input
                      type="text"
                      value={item.remark || ""}
                      onChange={(e) =>
                        onUpdate(index, "remark", e.target.value)
                      }
                      className={`w-full p-1 border rounded ${item.isYes ? "bg-white/80" : ""}`}
                      readOnly={readOnly}
                    />
                  </td>
                  {!readOnly && (
                    <td className="border p-2 text-center">
                      <button
                        type="button"
                        onClick={() => onRemove(index)}
                        className="text-red-700 hover:text-red-900 font-medium bg-white/60 px-2 py-1 rounded"
                      >
                        Remove
                      </button>
                    </td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RCAConsequencesSection;
